module.exports = __webpack_public_path__ + "static/media/ipad_10_9_inch_air_purple.22189f67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/ipad_10_9_inch_air_purple.png
// module id = 2107
// module chunks = 0